<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  // created () {
  //   this.$nextTick(() => {
  //     this.resizeFun()
  //     window.addEventListener('resize', this.resizeFun)
  //   })
  // },
  // methods: {
  //   resizeFun () {
  //     const devicePixelRatio = window.devicePixelRatio // 获取下载的缩放 125% -> 1.25    150% -> 1.5
  //     if (devicePixelRatio !== 1) {
  //       // 如果在笔记本中用IE浏览器打开 则弹出提示
  //       if (!! window.ActiveXObject || 'ActiveXObject' in window) {
  //         // alert('balabala。。。')
  //       } else {
  //         const c = document.querySelector('body')
  //         c.style.zoom = 1 / devicePixelRatio// 修改页面的缩放比例
  //       }
  //     }
  //   }
  // },
  mounted(){
    // function checkIE(){
    //   return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    // }
    // if (checkIE()) {
    //   window.addEventListener('hashchange', () => {
    //     var currentPath = window.location.hash.slice(1);
    //     if (this.$route.path !== currentPath) {
    //     this.$router.push(currentPath)
    //   }
    // }, false)
    // }
  },
}
</script>

<style lang="scss">
  @import '~@/assets/style/public-class.scss';
  :root {
          --el-color-primary: #02C362;
        }
</style>
